<!--
 * @Author: 朱占为
 * @LastEditors: majungcy majun18705161998@163.com
 * @description: page description
 * @Date: 2021-07-16 13:16:52
 * @LastEditTime: 2022-07-15 10:32:19
-->
<template>
  
  <router-view v-slot="{ Component, route }">
    <transition :name="transitionName">
      <component :is="Component" :key="route.path" />
    </transition>
  </router-view>


  <div v-if="isActivated" class="active-message flex align-center justify-center">
    <p>
      <span class="active" @click="handleActiveAccount">Activate</span>
      <span>Enjoy more discounts</span>
      <van-icon name="cross" @click="hideActive" />
    </p>
  </div>

  <div>
    <div v-for="it in listWordForDialog" :key="it.treeKey">
      <CoverPackage
        :visible="orderDialogShow"
        :order="it.order"
        :word-list="it.wordList"
      />
    </div>
  </div>
</template>

<script>
import { computed, getCurrentInstance,watchEffect,ref,inject ,onMounted, onUnmounted, toRefs, nextTick, reactive } from 'vue';
import { getUserSource } from 'src/model/user-source'
import { useRouter } from 'vue-router';
import { Dialog,Notify } from 'vant';
import { useStore } from 'vuex'

import { getCoverPackageDialog } from './model/order'
//全局弹窗
import CoverPackage from './components/CoverPackage/CoverPackage'

export default {
  name: 'App',
  components: {
    CoverPackage
  },
  setup() {
    const Post = inject('$post')
    const disableSendEmail=ref(false)
    const show=ref(true)
    const isActivated=computed(()=>{
      return show.value && window.$mine && window.$mine.state===3
    })
    // const route = useRoute();
    const router = useRouter();
    const store = useStore()
    // const route = useRoute();
    //   const store = useStore();
    const instance = getCurrentInstance();
    const api = instance.appContext.config.globalProperties.$url;
    
    const transitionName = ref('slide')
    // 路由动画设置
    // watchEffect(() => {
    //   const transitionFadeRoute=['/wap/order','/wap/service','/wap/mine']
    //   transitionName.value = transitionFadeRoute.includes(router.currentRoute.value.path)?'fade':'slide'
    // })
    



    // 重新发送邮箱
    const resendMail=async()=> {
      if (disableSendEmail.value) {
        Notify({
          message: 'Please try later',
          color: '#F99945',
          background: '#fef5ec',
        });
        return
      }
      const res = await Post('User/reSendMail', {
        mail: window.$mine.mail,
        lastUrl: sessionStorage.getItem('routerPath') ? JSON.parse(sessionStorage.getItem('routerPath')) : '/',
        utm: getUserSource()
      })
      if (res.code==0) {
        disableSendEmail.value = true
        setTimeout(() => {
          disableSendEmail.value = false
        }, 10 * 1000)
        Dialog.alert({
          message:
          `We have already sent you an email to "<b>${window.$mine.mail}</b>" and please follow the instruction to activate your account. If you have not received the activation email, please check the spam mailbox.
          Please Active Your Account`,
          confirmButtonText:'ok',
          allowHtml: true
        })
      }
    }
    const handleActiveAccount=()=>{
      resendMail()
    }
    const hideActive=()=>{
      show.value=false
    }

    const getDeviceType = () => {
      var u = navigator.userAgent //获取到的是个字符串，包括很多信息，我只匹配我想要的信息
      return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //判断是苹果手机
    }

    //是否ios左右滑动
    const isIosMoveBack = computed(() => {
      return store.state.dashboard.isIosMoveBack
    })
    // 路由动画设置
    watchEffect(() => {
      // 路由过渡动画的监听判断
      if(isIosMoveBack.value){
        // 清除过渡效果
        transitionName.value = ''
        // 重置监听状态
        store.commit('dashboard/setIsIosMoveBack', false)
      }else{
        // 加上过渡效果
        const transitionFadeRoute = ['/wap/order', '/wap/support', '/wap/mine']
        transitionName.value = transitionFadeRoute.includes(
          router.currentRoute.value.path
        )
          ? 'fade'
          : 'slide'
      }
    })
    
    
    //全局弹窗state
    const orderDialogShow = ref(false)
    const dialog_state = reactive({
      orderInterval: null,
      listWordForDialog: []
    })

    const getOrderComplete = async () => {
      const res = await getCoverPackageDialog()
      if (res && res.count > 0) {
        dialog_state.listWordForDialog = res.list.map((it) => {
          return {
            ...it,
            treeKey: it.order._id + +new Date()
          }
        })
      }
    }
    const getVisible = () => {
      nextTick(() => {
        const isFirstOff = sessionStorage.getItem((window.$mine && window.$mine.id + '_HideFirstOffDialog'))
        const isActOff = sessionStorage.getItem((window.$mine && window.$mine.id + '_HideActivityOffDialog'))
        const isGuideOff = sessionStorage.getItem((window.$mine && window.$mine.id + '_GuideDialog'))
        const isFirstOffRes = isFirstOff === null || isFirstOff === undefined ? true : !!(isFirstOff === 'true' || isFirstOff === true)
        const isActOffRes = isActOff === null || isActOff === undefined ? true : !!(isActOff === 'true' || isActOff === true)
        const isGuideOffRes = isGuideOff === null || isGuideOff === undefined ? true : !!(isGuideOff === 'true' || isGuideOff === true)
        const isShow = isFirstOffRes && isActOffRes && isGuideOffRes
        console.log(isFirstOffRes, isActOffRes, isGuideOffRes)
        orderDialogShow.value = isShow
      })
    }
    const setListenerSession = () => {
      var sessionStorageMock = (function(win) {
        var storage = win.sessionStorage
        return {
          setItem: function(key, value) {
            var setItemEvent = new Event('setItemEvent')
            var oldValue = storage[key]
            setItemEvent.key = key
            // 新旧值深度判断，派发监听事件
            if (oldValue !== value) {
              setItemEvent.newValue = value
              setItemEvent.oldValue = oldValue
              win.dispatchEvent(setItemEvent)
              storage[key] = value
              return true
            }
            return false
          },
          getItem: function(key) {
            return storage[key]
          },
          removeItem: function(key) {
            storage[key] = null
            return true
          },
          clear: function() {
            storage.clear()
            return true
          },
          key: function(index) {
            return storage.key(index)
          }
        }
      }(window))

      Object.defineProperty(window, 'sessionStorage', { value: sessionStorageMock, writable: true })
    }
    
    
    onMounted(() => {
      store.dispatch('user/getTempActivity')
      // 监听到滑动事件时设为true
      if (getDeviceType()) {
        document.body.addEventListener(
          'touchmove',
          () => {
            store.commit('dashboard/setIsIosMoveBack', true)
          },
          false
        )
      }


      //触发全局弹窗
      getOrderComplete()
      dialog_state.orderInterval = setInterval(() => {
        getOrderComplete()
      }, 60000)
      setListenerSession()
      getVisible()
      window.addEventListener('setItemEvent', (e) => {
        const mineId = window.$mine && window.$mine.id
        if (e.key.includes(mineId)) {
          getVisible()
        }
      })
    })

    onUnmounted(() => {
      dialog_state.orderInterval = null
      window.removeEventListener('setItemEvent', (e) => {
        const mineId = window.$mine.id
        if (e.key.includes(mineId)) {
          getVisible()
        }
      })
    })


    
    
    return {
      router,
      api,
      isActivated,
      disableSendEmail,
      resendMail,
      handleActiveAccount,
      hideActive,
      transitionName,
      isIosMoveBack,
      getDeviceType,

      ///全局弹窗state
      ...toRefs(dialog_state),
      orderDialogShow
    };
  },
 
  methods: {
    gopath(path) {
      this.router.push({
        path
      });
    }
  }
};
</script>

<style lang="scss" scoped>
// .v-enter-active,
// .v-leave-active { transition: all 0.3s; }

// .v-enter,
// .v-leave-to { transform: translateX(100%); }

.slide-enter-active,
.slide-leave-active {
  transition: all 0.5s;
  opacity: 1;
}

.slide-enter-from,
.slide-leave-to {
  transform: translateX(100%);
  opacity: 1;
  background: $bgColor;
  z-index: 10005;
}

.active-message {
  position: fixed;
  bottom: 100px;
  z-index: 10000;
  width: 240px;
  left: 50%;
  transform: translateX(-50%);

  p {
    height: 16px;
    line-height: 16px;
    border-radius: 13px;
    box-shadow: 0 0 10px rgba(30, 24, 63, 0.1);
    background: #fff;
    padding: 5px 10px;
    color: $fontColor;

    span {
      &.active {
        color: #faa755;
        font-weight: bold;
        margin-right: 10px;
      }

      &:nth-child(2) {
        margin-right: 8px;
      }
    }

    i {
      color: #ccc;
    }
  }
}

// .Router {
//   position: absolute;
//   width: 100%;
//   height: 100%;
//   padding-bottom: 60px;
//   transition: all 300ms ease;
//   box-sizing: border-box;
//   overflow: auto;
// }

// .slide-left-enter,
// .slide-right-leave-active {
//   opacity: 0;
//   -webkit-transform: translate(100%, 0);
//   transform: translate(100%, 0);
// }

// .slide-left-leave-active,
// .slide-right-enter {
//   opacity: 0;
//   -webkit-transform: translate(-100%, 0);
//   transform: translate(-100% 0);
// }
</style>
